export function filterPositiveCourseThresholds<T>(
  courseThresholds: Record<string, T> | undefined,
  getNumericValue: (value: T) => number | null | undefined
): Record<string, number> {
  return Object.entries(courseThresholds ?? {}).reduce<Record<string, number>>(
    (acc, [courseName, threshold]) => {
      const numericThreshold = getNumericValue(threshold)
      if (numericThreshold === undefined || numericThreshold === null) {
        return acc
      }

      if (!Number.isFinite(numericThreshold) || numericThreshold <= 0) {
        return acc
      }

      acc[courseName] = numericThreshold
      return acc
    },
    {}
  )
}
